import { PermissionRules, PERMISSIONS, type Permission } from '@teamworksdev/influencer/core';
import { isAgent } from './roles';

const hasContentHubRead = PermissionRules.hasAnyTeamPermission([
	PERMISSIONS.TEAM_ADMIN,
	PERMISSIONS.TEAM_CONTENT_HUB_WRITE,
	PERMISSIONS.TEAM_CONTENT_HUB_READ,
]);

const hasContentHubTaggedOnlyRead = PermissionRules.hasAnyTeamPermission([
	PERMISSIONS.TEAM_ADMIN,
	PERMISSIONS.TEAM_CONTENT_HUB_WRITE,
	PERMISSIONS.TEAM_CONTENT_HUB_READ,
	PERMISSIONS.TEAM_CONTENT_HUB_MEDIA_TAGGED_ONLY_READ,
]);

const readContentHub = PermissionRules.or(
	PermissionRules.hasAnyTeamPermission([
		PERMISSIONS.TEAM_CONTENT_HUB_READ,
		PERMISSIONS.TEAM_CONTENT_HUB_WRITE,
		PERMISSIONS.TEAM_ADMIN,
	]),
	isAgent,
);

const CONTENT_HUB_WRITE_PERMISSION_IDS: readonly Permission[] = [
	PERMISSIONS.TEAM_CONTENT_HUB_WRITE,
	PERMISSIONS.TEAM_ADMIN,
];

const hasContentHubWrite = PermissionRules.hasAnyTeamPermission([...CONTENT_HUB_WRITE_PERMISSION_IDS]);

const accessContentHubMyContent = PermissionRules.or(
	hasContentHubTaggedOnlyRead,
	isAgent,
);

const accessContentHub = PermissionRules.or(
	hasContentHubTaggedOnlyRead,
	isAgent,
);

const accessContentHubActivity = hasContentHubWrite;

const accessContentHubDashboard = hasContentHubWrite;

const accessContentHubGalleries = PermissionRules.or(
	hasContentHubRead,
	isAgent,
);

const accessContentHubGallery = PermissionRules.or(
	hasContentHubRead,
	isAgent,
);

const accessContentHubGalleryMedia = PermissionRules.or(
	hasContentHubRead,
	isAgent,
);

export {
	CONTENT_HUB_WRITE_PERMISSION_IDS,
	hasContentHubRead,
	hasContentHubTaggedOnlyRead,
	readContentHub,
	accessContentHubMyContent,
	accessContentHub,
	accessContentHubActivity,
	hasContentHubWrite,
	accessContentHubGalleries,
	accessContentHubGallery,
	accessContentHubGalleryMedia,
	accessContentHubDashboard,
};
